import React from 'react';
import { useTranslation } from 'react-i18next';

function KycStepOptionsModal({
  isOpen,
  fieldName,
  options,
  newOption,
  onNewOptionChange,
  onAddOption,
  onUpdateOption,
  onRemoveOption,
  onOptionBlur,
  onClose,
}) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t('kyc.editOptionsTitle')}: {fieldName || t('kyc.fieldLabel')}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="table-responsive border rounded">
                <table className="table table-sm align-middle mb-0">
                  <tbody>
                    {(Array.isArray(options) ? options : []).map((option, optionIndex) => (
                      <tr key={`option-${optionIndex}`}>
                        <td>
                          <input
                            className="form-control form-control-sm"
                            value={option}
                            onChange={(event) => onUpdateOption(optionIndex, event.target.value)}
                            onBlur={onOptionBlur}
                          />
                        </td>
                        <td style={{ width: '1%' }} className="text-nowrap">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => onRemoveOption(optionIndex)}
                            title={t('kyc.deleteOption')}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          placeholder={t('kyc.newOption')}
                          value={newOption}
                          onChange={(event) => onNewOptionChange(event.target.value)}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                              event.preventDefault();
                              onAddOption();
                            }
                          }}
                        />
                      </td>
                      <td style={{ width: '1%' }} className="text-nowrap">
                        <button
                          type="button"
                          className="btn btn-sm btn-theme"
                          onClick={onAddOption}
                          title={t('kyc.addOption')}
                        >
                          <i className="fa fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" onClick={onClose}>{t('kyc.closeButton')}</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default KycStepOptionsModal;
